import {
    getContactUsMessage,
    getContactUsMessagesFetchError,
    getContactUsMessagesIsFetching,
} from '@selectors/contactUsMessages';
import { useDispatch, useSelector } from 'react-redux';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';
import { RootState } from '@reducers/index';
import { useEffect } from 'react';
import { fetchSingleContactUsMessage } from '@actions/contactUsMessages';

const useFetchSingleContactUsMessage = (id: number): Hook => {
    const dispatch = useDispatch();

    const message = useSelector((state: RootState) => getContactUsMessage(state, id));
    const isFetching = useSelector(getContactUsMessagesIsFetching);
    const fetchError = useSelector(getContactUsMessagesFetchError);

    useEffect(() => {
        dispatch(fetchSingleContactUsMessage(id));
    }, [dispatch, id]);

    return { message, isFetching, fetchError };
};

interface Hook {
    message: ContactUsMessage;
    isFetching: boolean;
    fetchError: string | null;
}

export default useFetchSingleContactUsMessage;
